import { render, staticRenderFns } from "./ChangelogDiffHeader.vue?vue&type=template&id=30013f3c&scoped=true&"
import script from "./ChangelogDiffHeader.vue?vue&type=script&lang=js&"
export * from "./ChangelogDiffHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogDiffHeader.vue?vue&type=style&index=0&id=30013f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30013f3c",
  null
  
)

export default component.exports